import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterApprovalLogsView.
 * Extends JetView to create a view for filtering approval logs.
 */
export default class FilterApprovalLogsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar'),
                            value: '3',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: '3', value: _('Pendiente') },
                                { id: '1', value: _('Aprobada') },
                                { id: '2', value: _('Rechazada') },
                                { id: 'NE', value: _('No Ejecutado') },
                                { id: 'I', value: _('Iniciada') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'country-hide prm-filterByCountry',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            hidden: !devConfig.getPermAction("viewTypeVerification", "Add"), // Oculta el campo si el usuario no tiene permiso para ver el tipo de verificación.
                            view: "richselect", // Tipo de componente (selección desplegable).
                            name: "TypeVerification", // Nombre identificador del campo.
                            label: _("Origen"), // Etiqueta con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar"), // Texto de ayuda dentro del campo.
                            options: [ // Opciones disponibles en el desplegable.
                                {id: "0", value: _("Manual")},
                                {id: "1", value: _("Proveedor")}
                            ]
                        },
                        {
                            hidden: !devConfig.getPermAction("viewTypeReport", "Add"), // Oculta el campo si el usuario no tiene permiso para ver el tipo de reporte.
                            view: "richselect", // Tipo de componente (selección desplegable).
                            name: "Type", // Nombre identificador del campo.
                            label: _("Tipo Reporte"), // Etiqueta con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar"), // Texto de ayuda dentro del campo.
                            options: [ // Opciones disponibles en el desplegable.
                                {id: "0", value: _("Verificación de datos")},
                                {id: "1", value: _("Actualización de datos")}
                            ]
                        },
                        {
                            hidden: !devConfig.getPermAction("viewTypeDecision", "Add"), // Oculta el campo si el usuario no tiene permiso para ver el tipo de decisión.
                            view: "richselect", // Tipo de componente (selección desplegable).
                            name: "TypeDecision", // Nombre identificador del campo.
                            label: _("Tipo Decisión"), // Etiqueta con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar"), // Texto de ayuda dentro del campo.
                            options: [ // Opciones disponibles en el desplegable.
                                {id: "0", value: _("Operador")},
                                {id: "1", value: _("Automatico")}
                            ]
                        },
                        {
                            hidden: !devConfig.getPermAction("viewRejectionReason", "Add"), // Oculta el campo si el usuario no tiene permiso para ver los motivos de rechazo.
                            view: "richselect", // Tipo de componente (selección desplegable).
                            name: "Note", // Nombre identificador del campo.
                            id: "RejectionReason", // Identificador único del componente.
                            label: _("Motivo de rechazo"), // Etiqueta con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar") // Texto de ayuda dentro del campo.
                        },
                        {
                            //Si los campos relacionados al permiso esta deshabilitados para el usuario, se coloca una columna sin propiedades para no dañar la estructura de columnas
                            hidden: devConfig.getPermAction("viewTypeVerification", "Add") || devConfig.getPermAction("viewTypeReport", "Add") || devConfig.getPermAction("viewTypeDecision", "Add") || devConfig.getPermAction("viewRejectionReason", "Add"),
                        }
                    ]
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'radio',
                            label: 'Tipo',
                            name: 'Overall',
                            id: 'Overall',
                            labelPosition: 'top',
                            options: [
                                { id: 0, value: 'Detallado' },
                                { id: 1, value: 'Total' },
                            ],
                            value: 0,
                        },
                        {
                            hidden: !devConfig.getPermAction("viewVerificationProvider", "Add"), // Oculta el campo si el usuario no tiene permiso para ver el proveedor de verificación.
                            view: "richselect", // Tipo de componente (selección desplegable).
                            name: "VerificationProvider", // Nombre identificador del campo.
                            id: "VerificationProvider", // Identificador único del componente.
                            label: _("Proveedor de verificación"), // Etiqueta con soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar") // Texto de ayuda dentro del campo.
                        },
                        {},
                        {},
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const row_1 = {
            id: 'r1',
            rows: [
                {
                    margin: 15,
                    responsive: 'r1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            id: 'Id',
                            maxWidth: 200,
                            css: 'my_input',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            labelPosition: 'top',
                            required: true,
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter',
                            width: 110,
                            css: 'my_btn',
                            height: 38,
                            click: () => {
                                let userId = $$('Id').getValue();
                                if (userId != '') {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .get(devConfig.geturlApi() + 'es/Client/GetClientById?id=' + userId, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message('Error! ');
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var userSelected = [];
                                                $$('form').clear();
                                                var resp = JSON.parse(text);
                                                if (resp.length > 0) {
                                                    userSelected.push(resp[0]);
                                                    if (
                                                        userSelected[0].DNIA != undefined &&
                                                        userSelected[0].DNIA != null &&
                                                        userSelected[0].DNIA != ''
                                                    ) {
                                                        $$('previewAnt').setValues({
                                                            src: userSelected[0].DNIA,
                                                        });
                                                    }
                                                    if (
                                                        userSelected[0].DNIP != undefined &&
                                                        userSelected[0].DNIP != null &&
                                                        userSelected[0].DNIP != ''
                                                    ) {
                                                        $$('previewPos').setValues({
                                                            src: userSelected[0].DNIP,
                                                        });
                                                    }
                                                    $$('form').parse(userSelected);
                                                }
                                            },
                                        });
                                }
                            },
                        },
                    ],
                },
            ],
        };
        const row_2 = {
            id: 'r2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r2',
                    cols: [
                        {
                            view: 'datepicker',
                            name: 'BirthDate',
                            id: 'BirthDate',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de nacimiento'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                            required: true,
                        },
                        {
                            view: 'text',
                            name: 'MiddleName',
                            minWidth: 200,
                            label: _('Segundo Nombre'),
                            labelPosition: 'top',
                            required: true,
                        },
                        {
                            view: 'text',
                            name: 'SecondLastName',
                            minWidth: 200,
                            label: _('Segundo Apellido'),
                            labelPosition: 'top',
                            required: true,
                        },
                    ],
                },
            ],
        };
        const row_3 = {
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    id: 'r3',
                    rows: [
                        {
                            responsive: 'r3',
                            cols: [
                                {
                                    rows: [
                                        {
                                            id: 'previewAnt',
                                            view: 'template',
                                            css: 'preview',
                                            template: '<img class="previewImage" src="#src#">',
                                            data: { src: null },
                                            minWidth: 200,
                                            minHeight: 200,
                                        },
                                        {
                                            name: 'ImageAnt',
                                            id: 'ImageAnt',
                                            view: 'uploader',
                                            multiple: false,
                                            autosend: false,
                                            css: 'previewButton',
                                            accept: 'image/png, image/jpg, image/jpeg',
                                            label: _('Subir DNI Anterior'),
                                            minWidth: 200,
                                            labelWidth: 180,
                                            on: {
                                                onAfterFileAdd: function (uploadedFile) {
                                                    if (uploadedFile.size && uploadedFile.size < 1024000) {
                                                        const reader = new FileReader();
                                                        reader.addEventListener(
                                                            'load',
                                                            function (event) {
                                                                const base64 = reader.result;
                                                                $$('previewAnt').setValues({
                                                                    src: base64,
                                                                });
                                                            },
                                                            false,
                                                        );
                                                        if (uploadedFile) {
                                                            reader.readAsDataURL(uploadedFile.file);
                                                        }
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: 'El tamaño maximo permitido de las imágenes es de 1024 KB',
                                                        });
                                                    }
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    rows: [
                                        {
                                            id: 'previewPos',
                                            view: 'template',
                                            css: 'preview',
                                            template: '<img class="previewImage" src="#src#">',
                                            data: { src: null },
                                            minWidth: 200,
                                            minHeight: 200,
                                        },
                                        {
                                            name: 'ImagePos',
                                            id: 'ImagePos',
                                            view: 'uploader',
                                            multiple: false,
                                            autosend: false,
                                            accept: 'image/png, image/gif, image/jpeg',
                                            label: _('Subir DNI Posterior'),
                                            css: 'previewButton',
                                            minWidth: 200,
                                            labelWidth: 180,
                                            on: {
                                                onAfterFileAdd: function (uploadedFile) {
                                                    if (uploadedFile.size && uploadedFile.size < 1024000) {
                                                        const reader = new FileReader();
                                                        reader.addEventListener(
                                                            'load',
                                                            function (event) {
                                                                const base64 = reader.result;
                                                                $$('previewPos').setValues({
                                                                    src: base64,
                                                                });
                                                            },
                                                            false,
                                                        );
                                                        if (uploadedFile) {
                                                            reader.readAsDataURL(uploadedFile.file);
                                                        }
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: 'El tamaño maximo permitido de las imágenes es de 1024 KB',
                                                        });
                                                    }
                                                },
                                            },
                                        },
                                        {
                                            view: 'label',
                                            align: 'center',
                                            label: _('El DNI posterior ya fue verificado.'),
                                            minWidth: 200,
                                            css: 'my-label-vc',
                                            id: 'DNPV',
                                            hidden: true,
                                        },
                                        {
                                            view: 'label',
                                            align: 'center',
                                            label: _('El DNI posterior esta en proceso de validación.'),
                                            minWidth: 200,
                                            css: 'my-label-vc',
                                            id: 'DNPPV',
                                            hidden: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            margin: 0,
                            rows: [
                                {
                                    view: 'label',
                                    align: 'center',
                                    label: _('Las extensiones de archivo disponibles son: JPEG, JPG, PNG'),
                                    minWidth: 200,
                                    css: 'my-label-vc',
                                },
                                {
                                    view: 'label',
                                    align: 'center',
                                    label: _(
                                        'El tamaño sugerido de las imágenes es de 1024 KB. El proceso de verificación tarda de 12 a 48 horas hábiles',
                                    ),
                                    minWidth: 200,
                                    css: 'my-label-vc',
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const button = {
            id: 'r4',
            rows: [
                {
                    margin: 10,
                    responsive: 'r4',
                    cols: [
                        {
                            view: 'button',
                            id: 'button',
                            value: _('Guardar'),
                            type: 'form',
                            click: () => {
                                const newdata = $$('form').getValues();
                                if ($$('form').validate()) {
                                    newdata.BirthDate = newdata.BirthDate.replace(' 00:00:00', '');
                                    if (
                                        $$('previewAnt').getValues().src != 'https://i.stack.imgur.com/lnYep.png' &&
                                        $$('previewPos').getValues().src != 'https://i.stack.imgur.com/lnYep.png'
                                    ) {
                                        newdata.ImageAnt = $$('previewAnt').getValues().src;
                                        newdata.ImagePos = $$('previewPos').getValues().src;
                                        var vthis = this;
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(devConfig.geturlApi() + 'Client/verifyAccount', newdata, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    $$('addVerification').hide();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var data = JSON.parse(text);
                                                    if (!data.HasError) {
                                                        webix.message('¡Verificación creada!');
                                                    } else {
                                                        webix.message({
                                                            title: '¡Error!',
                                                            type: 'alert-error',
                                                            text: _('ERROR' + data.CodeError.toString()),
                                                        });
                                                    }
                                                    $$('addVerification').hide();
                                                },
                                            });
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Debes subir los DNI'),
                                        });
                                    }
                                }
                            },
                        },
                    ],
                },
            ],
        };
        const content = {
            view: 'scrollview',
            scroll: 'xy',
            css: 'my-scrollview-vc',
            body: {
                rows: [row_1, row_2, row_3],
            },
        };
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Agregar'),
                    hidden: !devConfig.getPermAction('addVerifyAccount', 'Add'),
                    css: 'prm-addVerifyAccount',
                    autowidth: true,
                    click: function () {
                        webix
                            .ui({
                                view: 'window',
                                id: 'addVerification',
                                move: false,
                                fullscreen: true,
                                position: 'center',
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Agregar Verificación'),
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close',
                                            click: function () {
                                                this.getTopParentView().hide();
                                            },
                                        },
                                    ],
                                },
                                body: {
                                    view: 'form',
                                    id: 'form',
                                    rows: [content, button],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate();
                                            },
                                        },
                                    },
                                },
                            })
                            .show();
                        $$('previewAnt').setValues({
                            src: 'https://i.stack.imgur.com/lnYep.png',
                        });
                        $$('previewPos').setValues({
                            src: 'https://i.stack.imgur.com/lnYep.png',
                        });
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('requests:filter', [filterdata]);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Agregar'),
                    hidden: !devConfig.getPermAction('addVerifyAccount', 'Add'),
                    css: 'prm-addVerifyAccount',
                    click: function () {
                        webix
                            .ui({
                                view: 'window',
                                id: 'addVerification',
                                move: false,
                                fullscreen: true,
                                position: 'center',
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Agregar Verificación'),
                                            align: 'center',
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close',
                                            click: function () {
                                                this.getTopParentView().hide();
                                            },
                                        },
                                    ],
                                },
                                body: {
                                    view: 'form',
                                    id: 'form',
                                    rows: [content, button],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate();
                                            },
                                        },
                                    },
                                },
                            })
                            .show();
                        $$('previewAnt').setValues({
                            src: 'https://i.stack.imgur.com/lnYep.png',
                        });
                        $$('previewPos').setValues({
                            src: 'https://i.stack.imgur.com/lnYep.png',
                        });
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear();
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('requests:filter', [filterdata]);
                        $$('filterPopup').hide();
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section],
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            id: 'formFilter',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });
        webix.ajax().get(devConfig.geturlApi() + 'Select/GetRejectionReason', {
            error: function (text, data, XmlHttpRequest) {
                webix.message('Error! ');
            },
            success: function (text, data, XmlHttpRequest) {
                let resp = JSON.parse(text);
                if (resp.data.length > 0) {
                    $$('RejectionReason').define('options', resp.data);
                    $$('RejectionReason').refresh();
                }
            },
        });
        webix.ajax().get(devConfig.geturlApi() + 'Select/GetProviderVerifications', {
            error: function (text, data, XmlHttpRequest) {
                webix.message('Error! ');
            },
            success: function (text, data, XmlHttpRequest) {
                let resp = JSON.parse(text);
                if (resp.data.length > 0) {
                    $$('VerificationProvider').define('options', resp.data);
                    $$('VerificationProvider').refresh();
                }
            },
        });
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
    }
}

// FILE DOCUMENTED
